import React, { useState, useEffect } from 'react';
import { FiGithub, FiExternalLink, FiServer, FiDatabase, FiBarChart2, FiShield } from 'react-icons/fi';
import { useData } from '../context/DataContext';
import SubscribeForm from '../components/SubscribeForm';

const GITHUB_USER = 'thewickedengineer';

const iconMap = {
  server: <FiServer />,
  database: <FiDatabase />,
  chart: <FiBarChart2 />,
  shield: <FiShield />,
};

const Projects = () => {
  const { projects } = useData();
  const [githubProjects, setGithubProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.github.com/users/${GITHUB_USER}/repos?sort=updated&per_page=30`)
      .then((r) => (r.ok ? r.json() : []))
      .then((repos) => {
        const existingUrls = new Set(projects.map((p) => p.github).filter(Boolean));
        const fresh = repos
          .filter((r) => !existingUrls.has(r.html_url))
          .map((r) => ({
            id: r.id,
            title: r.name.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
            description: r.description || 'No description provided.',
            tech: r.language ? [r.language] : [],
            github: r.html_url,
            demo: r.homepage || null,
            icon: 'server',
          }));
        setGithubProjects(fresh);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [projects]);

  const allProjects = [...projects, ...githubProjects];

  return (
    <div className="projects-page">
      <div className="page-header">
        <span className="section-label">Projects</span>
        <h1>Things I've <span className="highlight">Built</span></h1>
        <p>Open-source tools and side projects born from real engineering problems.</p>
      </div>

      {loading ? (
        <div className="loading-grid">
          {[1, 2, 3].map((i) => <div key={i} className="skeleton-card" />)}
        </div>
      ) : (
        <div className="projects-grid">
          {allProjects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-card-header">
                <div className="project-icon">
                  {iconMap[project.icon] || <FiServer />}
                </div>
                <div className="project-links">
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link" title="Source Code">
                      <FiGithub />
                    </a>
                  )}
                  {project.demo && (
                    <a href={project.demo} target="_blank" rel="noopener noreferrer" className="project-link" title="Live Demo">
                      <FiExternalLink />
                    </a>
                  )}
                </div>
              </div>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-tech">
                {(Array.isArray(project.tech) ? project.tech : project.tech.split(',')).map((t) => (
                  <span key={t} className="project-tech-tag">{t.trim()}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <SubscribeForm />
    </div>
  );
};

export default Projects;
